var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.79915C0 6.35617 0.450558 6.80845 1.00863 6.80845L3.99137 6.80824V9.79051C3.99137 10.3477 4.44318 10.7998 5 10.7998C5.55682 10.7998 6.00863 10.3477 6.00863 9.79051V6.80824L8.99135 6.80845C9.54819 6.80845 10 6.35634 10 5.79915C10 5.24197 9.54819 4.78986 8.99138 4.78986L6.00863 4.78965V1.8091C6.00863 1.25191 5.55682 0.799805 5 0.799805C4.44318 0.799805 3.99137 1.25191 3.99137 1.8091V4.78965L1.00862 4.78986C0.450551 4.78986 0 5.24214 0 5.79915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.8a3bed6cfb633cdb017d87df863280b7.svg";
export { ForwardRef as ReactComponent };